export default {"src":"/_next/static/media/profile-pro.2113bb7b.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};